import { dissoc } from 'ramda'

import { buildPlaceLevelsSnapshot } from '../../../utils/helpers/place'
import { reduceLevel } from './reduceLevel'

// Transforma o local vindo da API no estado inicial do formulário de edição:
// espalha os níveis em `placeLevel<id>` e guarda uma foto da hierarquia original
// (usada na hora de salvar para saber se a pessoa mudou algum nível).
export const formatPlaceForForm = place => ({
  ...dissoc('placeLevelsResume', reduceLevel(place)),
  __originalPlaceLevels: buildPlaceLevelsSnapshot(place.placeLevelsResume)
})
